module.exports = __webpack_public_path__ + "static/media/square-root.3e49c934.svg";